import { render } from "./InstructionsProgram.vue?vue&type=template&id=3db0ea79"
import script from "./InstructionsProgram.vue?vue&type=script&lang=js"
export * from "./InstructionsProgram.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__